import { Component } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { faHome, faKey, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { MustMatch } from '../_helpers/must-match.validators';
import { UserService } from '../_services';

@Component({
  selector: 'app-reset-password',
  standalone: false,
  templateUrl: './reset-password.html',
  styleUrl: './reset-password.css',
})
export class ResetPassword implements OnInit {
  resetPasswordForm!: FormGroup;
  loading = false;
  submitted = false;
  error = '';
  hasValidResetContext = false;
  resetToken = '';
  email = '';
  clientId = '';
  passwordPattern = '^[a-zA-Z0-9]{5,30}$';

  faHome = faHome;
  faKey = faKey;
  faPaperPlane = faPaperPlane;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private toastr: ToastrService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit() {
    this.resetPasswordForm = this.formBuilder.group(
      {
        password: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
        confirmPassword: ['', [Validators.required, Validators.pattern(this.passwordPattern)]],
      },
      {
        validators: [MustMatch('password', 'confirmPassword')],
      }
    );

    this.route.queryParams.subscribe((params) => {
      this.clientId = (params['client_id'] || '').trim();
      this.resetToken = (params['token'] || '').trim();
      this.email = (params['email'] || '').trim();

      this.hasValidResetContext = !!this.clientId && !!this.resetToken && !!this.email;

      if (!this.hasValidResetContext) {
        this.error = 'Invalid or incomplete reset link. Please request a new password reset email.';
      } else {
        this.error = '';
      }
    });
  }

  get f() {
    return this.resetPasswordForm.controls;
  }

  cancel() {
    this.router.navigate(['/login']);
  }

  onSubmit() {
    this.submitted = true;

    if (!this.hasValidResetContext) {
      this.toastr.error('Invalid reset link. Please request a new password reset email.', 'Error');
      return;
    }

    if (this.resetPasswordForm.invalid) {
      return;
    }

    this.loading = true;

    const data = this.resetPasswordForm.value;
    const request = {
      email: this.email,
      client_id: this.clientId,
      token: this.resetToken,
      new_password: data.password,
      confirm_password: data.confirmPassword,
    };

    this.userService.resetPassword(request).subscribe({
      next: (response) => {
        this.toastr.success(response.message, 'Success');
        this.loading = false;
        this.router.navigate(['/login']);
      },
      error: (err) => {
        this.toastr.error(err, 'Error');
        this.loading = false;
      },
    });
  }
}
